/**
 * @file automatically generated from MApp.Endpoints.LocalizationController
 */

import { MetadataClient } from '../metadataClient';
import { IBrowserLocalization, IAvailableLocalization } from '../models';

export class LocalizationClient extends MetadataClient {

	public static getAppLauncherLocalization(language: string) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v3/applauncher/localization?language=${encodeURIComponent(language)}`, {
				cache: 'no-cache'
			}),
			true
		);
	}

	public static getDesktopClientLocalization() {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v3/desktopclient/localization`, {
				cache: 'no-cache'
			})
		);
	}

	public static getBrowserLocalization(languageCode: string, timestamp: number) {
		return MetadataClient.ajax<IBrowserLocalization>(
			new Request(MetadataClient.endpointsUrl + `api/v4/browser/localization/${encodeURIComponent(languageCode)}?timestamp=${encodeURIComponent(timestamp)}`, {
				cache: 'no-cache'
			}),
			true
		);
	}

	public static getStudioLocalization() {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v3/studio/localization`, {
				cache: 'no-cache'
			})
		);
	}

	public static getSolutionLocalization(solution: string, component: string, name: string, format: string) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v1/studio/localization/${encodeURIComponent(solution)}/${encodeURIComponent(component)}/${encodeURIComponent(name)}?format=${encodeURIComponent(format)}`, {
				cache: 'no-cache'
			})
		);
	}

	public static getDefaultLocalization() {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v3/studio/localization/detect`, {
				cache: 'no-cache'
			}),
			true
		);
	}

	public static getLocalizations() {
		return MetadataClient.ajax<IAvailableLocalization[]>(
			new Request(MetadataClient.endpointsUrl + `api/v3/studio/localizations`, {
				cache: 'no-cache'
			}),
			true
		);
	}

	public static getAllLocalizations() {
		return MetadataClient.ajax<IAvailableLocalization[]>(
			new Request(MetadataClient.endpointsUrl + `api/v3/studio/localizations/all`, {
				cache: 'no-cache'
			})
		);
	}

	public static getCldrLocalization() {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v3/studio/localization/cldr`, {
				cache: 'no-cache'
			})
		);
	}

	public static getDefaultCldrLocalization() {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v3/studio/localization/cldr/detect`, {
				cache: 'no-cache'
			}),
			true
		);
	}

	public static getAvailableLocalizations() {
		return MetadataClient.ajax<IAvailableLocalization[]>(
			new Request(MetadataClient.endpointsUrl + `api/v3/localization/available`, {
				cache: 'no-cache'
			})
		);
	}
}
